import React, { useEffect, useMemo } from 'react'
import WindowDiagram from '../diagrams/WindowDiagram'

const ObscurityTab = ({
  formData,
  onChange,
  availableOptions,
  windowProduct
}) => {
  const isBayWindow = windowProduct.name === 'Bay'

  // Get selected end lite style for bay windows
  const selectedEndLiteStyle = useMemo(() => {
    if (!isBayWindow || !formData.end_lite_style_id) return null
    return availableOptions.end_lite_styles?.find(
      style => style.id === formData.end_lite_style_id
    )
  }, [isBayWindow, formData.end_lite_style_id, availableOptions.end_lite_styles])

  // Filter obscure glass options based on selected style for bay windows
  const obscureGlassOptions = useMemo(() => {
    if (!isBayWindow || !selectedEndLiteStyle) {
      return availableOptions.obscure_glass_options
    }

    const styleName = selectedEndLiteStyle.name.toLowerCase()

    if (styleName === 'double hung') {
      // Double Hung: Show top only, bottom only, and full options
      return availableOptions.obscure_glass_options?.filter(opt => {
        const name = opt.name.toLowerCase()
        return name.includes('top only') ||
               name.includes('bottom only') ||
               name.includes('full')
      })
    }

    if (styleName === 'casement') {
      // Casement: Show only "full" option
      return availableOptions.obscure_glass_options?.filter(opt => {
        const name = opt.name.toLowerCase()
        return name.includes('full')
      })
    }

    return availableOptions.obscure_glass_options
  }, [isBayWindow, selectedEndLiteStyle, availableOptions.obscure_glass_options])

  // Clear obscure glass option if it's incompatible with the selected style
  useEffect(() => {
    if (!isBayWindow || !formData.obscure_glass_option_id || !formData.end_lite_style_id) return

    const isOptionAvailable = obscureGlassOptions?.some(opt => opt.id === formData.obscure_glass_option_id)

    if (!isOptionAvailable) {
      onChange('obscure_glass_option_id', null)
    }
  }, [isBayWindow, formData.end_lite_style_id, formData.obscure_glass_option_id, obscureGlassOptions, onChange])

  return (
    <div className="space-y-6 py-4">
      <WindowDiagram
        windowTypeName={windowProduct.name}
        selectedValue={formData.obscure_glass_option_id}
        availableOptions={obscureGlassOptions}
        onChange={(value) => onChange('obscure_glass_option_id', value)}
        mode="obscurity"
        disabled={isBayWindow ? !formData.end_lite_style_id : false}
        formData={formData}
        allAvailableOptions={availableOptions}
      />
    </div>
  )
}

export default ObscurityTab
